export default __webpack_public_path__ + "static/media/trial-expired-img.94df5f9c.svg";